<template>
	<div class="full">
		<vxe-table :loading="loading" :data="tableData" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="static_time" title="统计日期">
				<template #default="{ row }">
					<span>{{$systemMethods.timestampToDate(row.static_time,true)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="validReplyUv1d" title="有效接待人数"></vxe-column>
			<vxe-column field="realPayAmt1d" title="净销售额"></vxe-column>
			<vxe-column field="conversionrate" title="转化率"></vxe-column>
			<vxe-column field="fstReplyDur1d" title="首响"></vxe-column>
			<vxe-column field="avgReplyDur1d" title="平响"></vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				tableData: [],
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if (this.row) {
				this.getdetail()
			}
		},
		computed: {

		},

		methods: {
			getdetail() {
				this.loading = true
				this.$api.stafflifecycle.list({
					id: this.row.id,
					son: 'stafflifecycle_detail',
					boxindex: 0
				}).then((res) => {
					this.tableData = res.list
					this.loading = false
				}, () => {
					this.loading = false
				})
			},

		},
		components: {

		}
	}
</script>